import { c as _c } from "react/compiler-runtime";
export type LogoProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "alt" | "src">;
export const Logo = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <img alt="" src="/brand/offrail-film-reel-mark.png" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};